import { Tabs }       from "@mantine/core";
import Typography     from "_components/atoms/typography";
import useStyles      from "./styles";
import UpdateFeedTabs from "./updatesFeedTabs";

const component = props => {
	const {
		activeTab,
		changeActiveTab,
		activeUpdateTab,
		changeUpdateTab
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<div
				className = { classes.appBar }
			>
				<Tabs
					classNames        = { {
						root     : classes.tabRoot,
						tabsList : classes.tabFlexContainer,
						tab      : classes.mantineTab
					} }
					onTabChange       = { changeActiveTab }
					value   = { activeTab }
				>
					<Tabs.List>

						<Tabs.Tab
							classes = { { root: classes.tabRoot } }
							// index   = { 0 }
							value = "ME"
						>
							<div className = { classes.textIconContainer }>
								<Typography
									className = { `${ activeTab === "ME" && classes.activeTabText } ${ classes.tabText }` }
									color     = { activeTab === "ME" ? "secondary" : "primary" }
									title     = { "Me" }
								/>
							</div>

						</Tabs.Tab>

						<Tabs.Tab
							classes = { { root: classes.tabRoot } }
							// index   = { 1 }
							value = "ACTIVITY"
						>
							<div className = { classes.textIconContainer }>
								<Typography
									className = { `${ activeTab === "ACTIVITY" && classes.activeTabText } ${ classes.tabText }` }
									color     = { activeTab === "ACTIVITY" ? "secondary" : "primary" }
									title     = { "Activity" }
								/>
							</div>

						</Tabs.Tab>

						<Tabs.Tab
							classes = { { root: classes.tabRoot } }
							value = "UPDATES"
						>
							<div className = { classes.textIconContainer }>
								<Typography
									className = { `${ activeTab === "UPDATES" && classes.activeTabText } ${ classes.tabText }` }
									color     = { activeTab === "UPDATES" ? "secondary" : "primary" }
									title     = { "Updates" }
								/>
							</div>

						</Tabs.Tab>
					</Tabs.List>
				</Tabs>
			</div>

			{
				activeTab === "UPDATES" ? (
					<UpdateFeedTabs
						activeUpdateTab = { activeUpdateTab }
						changeUpdateTab = { changeUpdateTab }
					/>
				) : null
			}
		</>
	);
};

export default component;
